import styled from 'styled-components';
import { isWithBackground } from '../utils';
export const StyledTabTitle = styled.div `
  width: 100%;
  margin-bottom: ${({ stylingType }) => (isWithBackground(stylingType) ? '0.125rem' : '0')};
  ${({ multiLine }) => (multiLine ? 'padding-top: 9px;padding-bottom:9px;' : '')};

  @media ${({ theme }) => theme.device.touch} {
    ${({ multiLine }) => (multiLine ? 'padding-top: 11px;padding-bottom:11px;' : '')};
  }
`;
